import _adminBookCall from './admin-book-call.png';
import _b2bDiscountsPromotionsGraphic from './b2b-discounts-promotions.png';
import _emails from './emails.png';
import _errorState from './error-state.svg';
import _frame29 from './frame-29.png';
import _pdfs from './pdfs.png';
import _priceEditorGraphic from './price-editor.png';
import _quantityPricingGraphic from './quantity-pricing-help.webp';
import _setUpSalesAgentsGraphic from './set-up-sales-agents.png';
import _takeB2bInternationalGraphic from './take-b2b-international.webp';
import _upgradeAnalytics from './upgrade-analytics.webp';
import _upgradeQuoting from './upgrade-quoting.png';
import _upgradeSalesAgents from './upgrade-sales-agents.png';
import { getSrc } from './utils';
import _viewB2BCustomersGraphic from './view-b2b-customers.png';

export const errorState = getSrc(_errorState);
export const setUpSalesAgentsGraphic = getSrc(_setUpSalesAgentsGraphic);
export const priceEditorGraphic = getSrc(_priceEditorGraphic);
export const b2bDiscountsPromotionsGraphic = getSrc(_b2bDiscountsPromotionsGraphic);
export const viewB2BCustomersGraphic = getSrc(_viewB2BCustomersGraphic);
export const takeB2bInternationalGraphic = getSrc(_takeB2bInternationalGraphic);
export const quantityPricingGraphic = getSrc(_quantityPricingGraphic);
export const frame29 = getSrc(_frame29);
export const adminBookCall = getSrc(_adminBookCall);
export const upgradeSalesAgents = getSrc(_upgradeSalesAgents);
export const upgradeQuoting = getSrc(_upgradeQuoting);
export const upgradeAnalytics = getSrc(_upgradeAnalytics);
export const pdfsGraphic = getSrc(_pdfs);
export const emailsGraphic = getSrc(_emails);
